import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Programme", href: "/activities" },
    { label: "Plan Your Visit", href: "/plan-your-visit" },
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-paper/95 backdrop-blur-sm border-b border-sand"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <Link
            to="/"
            data-testid="header-logo-link"
            className="font-serif text-lg sm:text-2xl font-semibold text-charcoal tracking-tight hover:text-forest transition-colors"
          >
            <span className="font-sans text-xs sm:text-sm font-bold uppercase tracking-widest text-bronze block leading-tight">Save the Date</span>
            McCartney Reunion, 22–23 Jan 2027
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={`text-base font-sans font-medium transition-colors ${
                  isActive(link.href)
                    ? "text-forest"
                    : "text-charcoal/70 hover:text-charcoal"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/register"
              data-testid="header-register-button"
              className="inline-flex items-center px-5 py-2.5 bg-charcoal text-paper text-sm font-sans font-medium rounded-md hover:bg-charcoal/85 transition-colors"
            >
              Register Interest
            </Link>
          </nav>

          {/* Mobile toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-charcoal"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Nav */}
        {mobileOpen && (
          <nav
            data-testid="mobile-nav"
            className="md:hidden pb-6 border-t border-sand pt-4"
          >
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  onClick={() => setMobileOpen(false)}
                  className={`text-lg font-sans font-medium ${
                    isActive(link.href)
                      ? "text-forest"
                      : "text-charcoal/70"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/register"
                onClick={() => setMobileOpen(false)}
                className="inline-flex items-center justify-center px-5 py-3 bg-charcoal text-paper text-base font-sans font-medium rounded-md"
              >
                Register Interest
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
